import _defineProperty from '@babel/runtime-corejs2/helpers/defineProperty';
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styledSystemPropTypes from '@styled-system/prop-types';
import styled, { css } from 'styled-components';
import { compose, background, border, color, layout, position, shadow, space, typography } from 'styled-system';
import { ifProp, prop } from 'styled-tools';
import { jsx } from 'react/jsx-runtime';
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const StyledText = styled('span').withConfig({
  displayName: "text__StyledText",
  componentId: "f8o3li-0"
})(["", " display:-webkit-box;line-height:1.5;", ""], ifProp('limitLinesOfTextTo', css(["overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], prop('limitLinesOfTextTo')), ""), compose(background, border, color, layout, position, shadow, space, typography));
const Text = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/jsx(StyledText, _objectSpread({
    ref: ref,
    fontSize: "sm",
    fontFamily: "default"
  }, props));
});
Text.displayName = 'Text';
Text.defaultProps = {
  'data-cy': 'Text' // component name
};
Text.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styledSystemPropTypes.space), styledSystemPropTypes.color), styledSystemPropTypes.background), styledSystemPropTypes.border), styledSystemPropTypes.layout), styledSystemPropTypes.position), styledSystemPropTypes.shadow), styledSystemPropTypes.typography), {}, {
  as: PropTypes.string,
  forwardAs: PropTypes.string,
  children: PropTypes.node.isRequired,
  limitLinesOfTextTo: PropTypes.number
});
export default Text;